import api from './client';

export interface Intervention {
  id: string;
  org_id: string;
  name: string;
  estimated_minutes: number;
  min_days_margin: number;
  type: string; // entretien, reparation, diagnostic, controle_technique, pneumatique, carrosserie
  active: boolean;
  fast: boolean;
  express_24h?: boolean; // bookable as soon as next day (e.g. carrosserie EAD photo expertise)
  forfait_code?: string; // local forfait code; when set, transferred to ServiceBox as "Forfait Local" (type 5) instead of Standard
  requires_details?: boolean; // when true, the booking flow asks the client for a free-text precision (e.g. diagnostic symptom)
}

export type InterventionCreate = Omit<Intervention, 'id'>;
export type InterventionUpdate = Partial<Omit<Intervention, 'id' | 'org_id'>>;

export const interventionsApi = {
  list: async (orgId: string): Promise<Intervention[]> => {
    const { data } = await api.get('/interventions', { params: { org_id: orgId } });
    return data;
  },

  create: async (intervention: InterventionCreate): Promise<Intervention> => {
    const { data } = await api.post('/interventions', intervention);
    return data;
  },

  update: async (id: string, updates: InterventionUpdate): Promise<Intervention> => {
    const { data } = await api.patch(`/interventions/${id}`, updates);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/interventions/${id}`);
  },
};
